import { Box, Button, Checkbox, FormControlLabel, FormGroup, Paper, Stack, TextField } from "@mui/material";
import { Form, FormikProvider, useFormik } from "formik";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import Loader3D from "../../../components/Loader/Loader3D";
import { getBatchAdmissionRegister, getStudentSubjects, updateStudentSubjects } from "../../../redux/features/batchSlice";
import { useSelector } from "react-redux";
import NoDataFound from "../../../components/NodataIndication/NoDataFound";

const SubjectEdit = ({ open, setOpen, dispatchParams, loading, rowData }) => {
  const { studentSubjects } = useSelector((state) => state.batch);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  useEffect(() => {
    if (open && rowData?.batch_assignment_id) {
      dispatch(getStudentSubjects(rowData?.batch_assignment_id));
      //   dispatch(getStudentSubjects(106));
    }
  }, [open]);

  const initialValues = {
    subjects: studentSubjects || [],
  };

  const schema = Yup.object({
    subjects: Yup.array().of(
      Yup.object().shape({
        assigned_subject_enrollment_id: Yup.string().required("Subject ID is required"),
        batch_assignment_subject_status: Yup.boolean().required("Subject status is required"),
      })
    ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      const data = { data: [...values.subjects] };
      dispatch(updateStudentSubjects(data)).then((res) => {
        if (res.payload.status === "error") {
          enqueueSnackbar(res.payload.message, { variant: "error" });
        } else if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, { variant: "success" });
          dispatch(getBatchAdmissionRegister(dispatchParams));
          handleCancel();
        }
      });
    },
  });
  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };
  const handleChange = (assigned_subject_enrollment_id, checked) => {
    formik.setFieldValue(
      "subjects",
      formik.values.subjects.map((subject) =>
        subject.assigned_subject_enrollment_id === assigned_subject_enrollment_id
          ? { ...subject, batch_assignment_subject_status: checked ? 1 : 0 }
          : subject
      )
    );
  };
  return (
    <GlobalDialog
      maxWidth={"sm"}
      fullWidth
      title={"Update Student's Subject"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      content={
        open ? (
          loading ? (
            <Loader3D />
          ) : Array.isArray(studentSubjects) && studentSubjects.length === 0 ? (
            <NoDataFound />
          ) : (
            <>
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Paper elevation={5}>
                    <Stack gap={2}>
                      <Box p={2}>
                        <FormGroup>
                          {formik.values?.subjects?.map((subject) => (
                            <FormControlLabel
                              key={subject?.assigned_subject_enrollment_id}
                              control={
                                <Checkbox
                                  onChange={(e) => handleChange(subject?.assigned_subject_enrollment_id, e.target.checked)}
                                  checked={subject?.batch_assignment_subject_status ? true : false}
                                />
                              }
                              label={subject?.subject_name}
                            />
                          ))}
                        </FormGroup>
                      </Box>
                    </Stack>
                  </Paper>
                  <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                    <Stack direction={"row"} spacing={1}>
                      <Button sx={{ boxShadow: "none" }} color="secondary" size="small" variant="contained" onClick={() => handleCancel()}>
                        Cancel
                      </Button>

                      <Button sx={{ boxShadow: "none" }} color="primary" size="small" variant="contained" type="submit">
                        {loading ? "Updating..." : "Update"}
                      </Button>
                    </Stack>
                  </Box>
                </Form>
              </FormikProvider>
            </>
          )
        ) : null
      }
    />
  );
};

export default SubjectEdit;
